import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import FadeIn from "@/components/FadeIn";
import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "L'estimation en ligne est-elle fiable ?",
    a: "Elle s'appuie sur les transactions réelles DVF, les indicateurs des notaires et des comparables récents de votre secteur. Elle donne une fourchette solide et documentée ; une visite confidentielle permet ensuite de l'affiner au plus juste.",
  },
  {
    q: "Que faites-vous de mes coordonnées ?",
    a: "Votre nom, téléphone et email servent uniquement à vous remettre votre estimation et, avec votre accord explicite, à vous recontacter au sujet de votre projet de vente. Vos données ne sont jamais cédées à des tiers.",
  },
  {
    q: "Quelles zones sont couvertes ?",
    a: "Toute l'Île-de-France : Paris intra-muros et les communes des Hauts-de-Seine, Yvelines, Val-de-Marne, Val-d'Oise, Seine-Saint-Denis, Seine-et-Marne et Essonne — dès lors qu'il s'agit d'un bien de caractère ou de prestige à la vente.",
  },
  {
    q: "Faites-vous de la location ou de la gestion ?",
    a: "Non. L'activité est exclusivement dédiée à la vente de biens haut de gamme, afin de concentrer toute l'expertise sur la valorisation de votre patrimoine.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-24 lg:py-32">
      <FadeIn>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">Questions fréquentes</p>
        <h2 className="font-display mt-4 text-2xl font-normal tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
          Tout ce qu'il faut savoir <em className="text-[#D4AF37]">avant de commencer.</em>
        </h2>
      </FadeIn>
      <div className="mt-12 border-t border-stone-800">
        {FAQS.map((f, i) => (
          <FadeIn key={f.q} delay={i * 0.06}>
            <div className="border-b border-stone-800">
              <button
                type="button"
                data-testid={`faq-question-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors hover:text-[#E5C158]"
              >
                <span className="font-display text-lg text-[#F5F3EF] sm:text-xl">{f.q}</span>
                <Plus
                  size={18}
                  className={`shrink-0 text-[#D4AF37] transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p data-testid={`faq-answer-${i}`} className="pb-6 pr-10 text-sm leading-relaxed text-stone-400">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
